import api from '@/api'

export default {
    namespaced: true,
    state: {},
    actions: {
        /**
         * NOTE: 申請加入學校
         * @return {Object}
         */
        async applySchool(context, schoolCode) {
            return new Promise(function(resolve) {
                api.ies5Api.applySchool(schoolCode).then(() => {
                    resolve(true)
                }).catch(() => {
                    resolve(true)
                })
            })
        }
    }
}
